module.exports = __webpack_public_path__ + "static/img_1745-6a171f598afaa38c387c5c941fc0ec0f.webp";